import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
var ResourceTypes = {
    youtube: "Vid\xe9o Youtube",
    pdf: "Document PDF",
    other: "Autre"
};
var ResourceCategory = {
    fiches: {
        name: "Nos fiches d'activit\xe9s p\xe9dagogiques \xe0 faire en classe",
        description: // "En vue d'une utilisation de la plateforme avec vos <strong>élèves de première et terminale générales et technologiques</strong>, nous vous proposons une série d'activités afin de les accompagner dans la période de réflexion autour des choix d'orientation sur Parcoursup.<br /><br />Les activités ont été imaginées sous forme de parcours, de la découverte des études supérieures aux choix d'orientation, en passant par la projection dans la vie étudiante et dans le monde professionnel.  Il est possible de sélectionner les activités qui correspondent aux besoins de vos élèves et ainsi créer une séquence pédagogique adaptée.<br /><br />Pour suivre l'ensemble des activités, il est toutefois recommandé que les lycéens créent un compte sur INSPIRE avec la <strong>fiche activité “Exploration de la plateforme INSPIRE”</strong> et complètent un profil lycéen avec la <strong>fiche activité “Mieux se connaître”</strong>.<br /><br />Ce profil lycéen peut-être créé autour du propre projet d’orientation du lycéen pour individualiser la démarche ou autour d'un personnage fictif pour permettre par exemple des réflexions en petits groupes. Les activités marquées de ce symbole 😃 peuvent se faire avec un personnage fictif.",
        "En vue d'une utilisation de la plateforme avec vos <strong>\xe9l\xe8ves de premi\xe8re et terminale</strong>, nous vous proposons une s\xe9rie d'activit\xe9s afin de les accompagner dans la p\xe9riode de r\xe9flexion autour des choix d'orientation.<br/><br/>Pour suivre l'ensemble des activit\xe9s, il est recommand\xe9 que les lyc\xe9ens cr\xe9ent un compte sur INSPIRE avec la <strong>fiche activit\xe9 “Exploration de la plateforme INSPIRE”</strong> et compl\xe8tent un profil lyc\xe9en avec la <strong>fiche activit\xe9 “Mieux se conna\xeetre”</strong>.<br/><br/>Les activit\xe9s marqu\xe9es de ce symbole \uD83D\uDE03\xa0peuvent se faire \xe0 l'aide du profil lyc\xe9en (fictif ou personnalis\xe9)."
    }
};
var ResourceCategoryName = function() {
    var res = {};
    for(var key in ResourceCategory){
        if (ResourceCategory.hasOwnProperty(key)) {
            res[key] = ResourceCategory[key].name;
        }
    }
    return res;
}();
var ResourceCategoryDescription = function() {
    var res = {};
    for(var key in ResourceCategory){
        if (ResourceCategory.hasOwnProperty(key)) {
            res[key] = ResourceCategory[key].description;
        }
    }
    return res;
}();
var ResourceSchema = new SimpleSchema({
    name: {
        type: String
    },
    url: {
        type: String
    },
    description: {
        type: String,
        optional: true
    },
    type: {
        type: String,
        allowedValues: Object.keys(ResourceTypes),
        autoform: {
            options: ResourceTypes
        }
    },
    category: {
        type: String,
        allowedValues: Object.keys(ResourceCategoryName),
        autoform: {
            options: ResourceCategoryName
        }
    },
    order: {
        label: "Priorit\xe9",
        type: Number,
        defaultValue: 0,
        optional: true
    }
});
export { ResourceSchema, ResourceCategory, ResourceTypes, ResourceCategoryName, ResourceCategoryDescription };
